import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function TrendingSidebar() {
  const hotArticles = getHotArticles(10);
  const top3 = hotArticles.slice(0, 3);
  const rest = hotArticles.slice(3);

  return (
    <aside className="space-y-5">
      <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-5 h-5 flex items-center justify-center text-accent-500">
            <i className="ri-fire-line text-lg"></i>
          </span>
          <h3 className="text-base font-semibold text-foreground-900">热搜排行</h3>
        </div>

        <div className="space-y-3">
          {top3.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex items-start gap-3 cursor-pointer group"
            >
              <span className={`flex-shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold ${
                index === 0
                  ? 'bg-primary-500 text-background-50'
                  : index === 1
                  ? 'bg-primary-400 text-background-50'
                  : 'bg-primary-300 text-background-50'
              }`}>
                {index + 1}
              </span>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-800 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h4>
                <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                  <span>{article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}</span>
                  <span className="text-accent-500 font-medium">{article.hotScore}°</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-3 pt-3 border-t border-background-200/50 space-y-2">
          {rest.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex items-center gap-3 cursor-pointer group"
            >
              <span className="flex-shrink-0 w-5 h-5 rounded flex items-center justify-center text-xs text-foreground-500 font-medium">
                {index + 4}
              </span>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm text-foreground-700 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h4>
              </div>
              <span className="flex-shrink-0 text-xs text-accent-500 font-medium">{article.hotScore}°</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-5 h-5 flex items-center justify-center text-primary-500">
            <i className="ri-flashlight-line text-lg"></i>
          </span>
          <h3 className="text-base font-semibold text-foreground-900">24小时热榜</h3>
        </div>
        <div className="space-y-3">
          {getHotArticles(5).map((article, index) => (
            <div key={article.id} className="flex items-center gap-2">
              <span className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold ${
                index < 3 ? 'bg-accent-100 text-accent-600' : 'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </span>
              <Link
                to={`/article/${article.id}`}
                className="flex-1 min-w-0 text-sm text-foreground-700 line-clamp-1 hover:text-primary-500 transition-colors"
              >
                {article.title}
              </Link>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{article.hotScore}°</span>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}